// extracted by mini-css-extract-plugin
export var chevron = "_48-d";
export var disabled = "_48-b";
export var error = "_48-c";
export var hideBorder = "_48-1";
export var icon = "_48-e";
export var input = "_48-0";
export var large = "_48-f";
export var open = "_48-9";
export var placeholder = "_48-a";
export var regular = "_48-5";
export var singleRowInput = "_48-2";
export var singleSelectInput = "_48-3 _48-0";
export var small = "_48-4";
export var spinnerContainer = "_48-i";
export var tag = "_48-7";
export var tagsContainer = "_48-8";
export var tagsInput = "_48-6 _48-0";
export var xSmall = "_48-g";
export var xxSmall = "_48-h";